export default "__VITE_ASSET__cfaca3d9__"